module.exports = __webpack_public_path__ + "static/media/img_dianbo.29d6d3e3.jpg";